import Service from "./apiService";

class AuthService extends Service {

  login(email, password) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `login`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
      bearerIsNeeded: false,
    });
  }

  getUser() {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `user`,
      method: "GET",
    });
  }
  
}

export var authService = new AuthService();
